import { render, staticRenderFns } from "./admins-edit.vue?vue&type=template&id=07248f77&scoped=true&"
import script from "./admins-edit.vue?vue&type=script&lang=js&"
export * from "./admins-edit.vue?vue&type=script&lang=js&"
import style0 from "./admins-edit.vue?vue&type=style&index=0&id=07248f77&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07248f77",
  null
  
)

export default component.exports